<template>
  <div>
    <v-chip
      class="ma-1"
      outlined
      v-for="(item, i) in items"
      :key="i"
      :href="item.link"
      target="_blank"
      :title="$t('Open {0} file', [item.link.includes('.pdf') ? 'pdf' : ''])"
    >
      <div class="px-1">
        <v-icon left v-show="item.link.includes('.pdf')">mdi-file-outline</v-icon>
        <span>{{ item.title }}</span>
      </div>
    </v-chip>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: [],
    },
  },
};
</script>

<style>
</style>
